__webpack_require__.p = "https://cdn.medprev.online/web-app/assets/7bdcd709/_next/";